import React from "react";

function Experts() {
  return (
    <section className="relative py-16 px-6 bg-[#f8f8f8] dark:bg-[#050505] overflow-hidden">
      {/* BACKGROUND EFFECTS */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-orange-500/10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />

      {/* GRID */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.05)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.05)_1px,transparent_1px)] bg-[size:70px_70px]" />

      <div className="relative z-10 max-w-7xl mx-auto grid md:grid-cols-2 gap-6 items-center">
        {/* LEFT IMAGE */}
        <div className="flex justify-center">
          <div className="relative">
            {/* IMAGE FRAME GLOW */}
            <div className="absolute -inset-2 bg-gradient-to-r from-orange-500/20 to-orange-300/20 blur-2xl rounded-3xl" />

            <img
              src="rahul.jpeg"
              alt="Interior Design Expert"
              className="relative w-[380px] h-[500px] object-cover rounded-3xl shadow-2xl border border-white/20"
            />

            {/* FLOAT BADGE */}
            <div className="absolute bottom-6 left-6 bg-white dark:bg-[#1a1a1a] px-4 py-3 rounded-xl border border-gray-200 dark:border-white/10 shadow-lg">
              <p className="text-sm font-semibold text-gray-900 dark:text-white">
                Web X Secure
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400">
                Interior Design Expert
              </p>
            </div>
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div>
          <div className="inline-flex w-fit my-4 items-center gap-2 px-5 py-2 rounded-full border border-primary/20 bg-primary/10 text-primary text-sm font-semibold">
            About Our Experts
          </div>
          <h2 className="myheading text-3xl md:text-5xl mb-6">
            Meet Our Creative
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
              {" "}
              Interior Designer
            </span>
          </h2>

          <p className="myparagraph  text-gray-600 dark:text-gray-400 max-w-xl mb-6">
            Our expert interior designer brings creativity, functionality, and
            modern aesthetics together to transform your space into something
            extraordinary. Every project is handled with precision, detail, and
            a deep understanding of client vision.
          </p>
          <p className="myparagraph  text-gray-600 dark:text-gray-400 max-w-xl mb-6">
            From concept planning to final execution, we ensure your space
            reflects luxury, comfort, and personality with perfect balance.
          </p>
          {/* TAG */}

          {/* HIGHLIGHT BAR */}
          <div className="mt-10 flex items-center gap-4">
            <div className="w-24 h-[3px] bg-primary rounded-full" />
            <div className="text-sm text-gray-500 dark:text-gray-400">
              Certified Interior Design Professional
            </div>
          </div>

          {/* SIGNATURE CARD */}
        </div>
      </div>
    </section>
  );
}

export default Experts;
